import type { ChainInfo, NetworkId, NetworkInfo } from "@alch/dx-entities";
import NetworkEmblem from "@components/ui/icons/NetworkEmblem";
import networkNameWithoutChain from "@util/networkNameWithoutChain";
import type React from "react";

export interface SelectedNetworksProps {
  values: NetworkId | NetworkId[];
  networkInfos: NetworkInfo[];
  chainInfo?: ChainInfo;
  placeholder?: React.ReactNode;
}

function SelectedNetworks({
  values,
  networkInfos,
  chainInfo,
  placeholder = "All networks",
}: SelectedNetworksProps) {
  const selectedNetworkInfos = networkInfos.filter((info) =>
    Array.isArray(values) ? values.includes(info.id) : values === info.id,
  );

  return (
    <div className="flex min-w-0 items-center gap-2">
      {selectedNetworkInfos.length > 0 ? (
        <div className="flex flex-row-reverse pl-2">
          {selectedNetworkInfos.slice(0, 5).map((info) => {
            return (
              <div key={info.id} className="relative -ml-2">
                <NetworkEmblem networkInfo={info} className="size-6" />
              </div>
            );
          })}
        </div>
      ) : null}

      <span className="min-w-0 truncate">
        {selectedNetworkInfos.length === 0
          ? placeholder
          : selectedNetworkInfos.length > 1
            ? `${selectedNetworkInfos.length} networks`
            : chainInfo
              ? networkNameWithoutChain({
                  chainInfo,
                  networkInfo: selectedNetworkInfos[0],
                })
              : selectedNetworkInfos[0].name}
      </span>
    </div>
  );
}

export default SelectedNetworks;
